module.exports = __webpack_public_path__ + "img/金属材料学1_3.b9397c03.png";